import { EditorStarterAsset } from '../../assets/assets';
import { EditorState } from '../types';

export const finishUpload = ({
  asset,
  remoteUrl: remoteUrl,
  state,
  remoteFileKey,
}: {
  state: EditorState;
  asset: EditorStarterAsset;
  remoteUrl: string;
  remoteFileKey: string;
}): EditorState => {
  const existingAsset = state.undoableState.assets[asset.id];
  const newAssets: Record<string, EditorStarterAsset> = {
    ...state.undoableState.assets,
    [asset.id]: {
      ...(existingAsset || {}),
      remoteUrl,
      remoteFileKey,
    } as EditorStarterAsset,
  };

  return {
    ...state,
    undoableState: {
      ...state.undoableState,
      assets: newAssets,
    },
    assetStatus: {
      ...state.assetStatus,
      [asset.id]: { type: 'uploaded' },
    },
  };
};
